import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  constructor(private http: HttpClient) { }

  getCategoryList(query): Observable<any> {
    return this.http.get(API_URL + "category" + query);
  }

  getCategoryListV2(): Observable<any> {
    return this.http.get(API_URL + "category/v2");
  }
  
  getCategoryWithoutAuthList(query): Observable<any> {
    return this.http.get(API_URL + "category/v1" + query);
  }

  getCategoryDetails(id): Observable<any> {
    return this.http.get(API_URL + "category/" + id);
  }
  getCategoryDetailsWithoutAuthList(query): Observable<any> {
    return this.http.get(API_URL + "category/v1" + query);
  }
  updateCategory(id, categorydata): Observable<any> {
    return this.http.put(API_URL + 'category/' + id, categorydata);
  }

  addCategory(categorydata): Observable<any> {
    return this.http.post(API_URL + 'category', categorydata);
  }

  getAllCategory(querystring): Observable<any> {
    return this.http.get(API_URL + "category/all/?" + querystring);
  }
  getAllDecendants(querystring): Observable<any> {
    return this.http.get(API_URL + "category/descendants/?" + querystring);
  }

  getAllSubDecendants(querystring): Observable<any> {
    return this.http.get(API_URL + "category/descendants/?" + querystring);
  }

  searchCategoryDetails(querystring): Observable<any> {
    return this.http.get(API_URL + 'category/?' + querystring);
  }

  getSubCategoryDetails(id): Observable<any> {
    return this.http.get(API_URL + "category/descendants/" + id);
  }

  getPerformanceCategories(id) {
    return this.http.get(API_URL + 'category/performancecategory/' + id);
  }


}
